import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { Globals } from 'src/app/globals';
import { SystemService } from '../../../service/system.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-cities',
  templateUrl: './cities.component.html',
  styleUrls: ['./cities.component.scss']
})
export class CitiesComponent implements OnInit {

  showLoader: boolean = false;
  cities: any;
  currentCityName = "";
  currentCityId = 0;

  constructor(private toastrService: ToastrService, public systemService: SystemService, public globals: Globals, private router: Router
    , public translate: TranslateService) { }


  ngOnInit(): void {
    this.getAllCities();
  }
  getAllCities() {
    this.showLoader = true;
    this.systemService.getAllCities()
      .subscribe(
        data => {
          this.cities = data;
          this.updateTable();
        },
        error => {
          this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
          this.showLoader = false

        },
        () => this.showLoader = false
      );

  }

  updateTable() {
    $("#datatable").DataTable().destroy();
    setTimeout(() => {
      $("#datatable").DataTable({
        pagingType: 'simple_numbers',
        // responsive: true,
        // columnDefs: [
        //   { responsivePriority: 1, targets: 0 },
        //   { responsivePriority: 10001, targets: 4 },
        //   { responsivePriority: 2, targets: -2 }
        // ],
        // "columnDefs": [
        //   { "orderable": false, "targets": [1, 2] }
        // ],
        pageLength: 5,
        lengthChange: false,
        info: true,
        search: {
          searchPlaceholder: "Search",
        },
        paging: true,
        language: {
          search: "",
          searchPlaceholder: "Search",
        },
      });
    }, 1);
  }
  getCurrentCity(cityId: any) {
    this.currentCityName = this.cities.filter((i: any) => i.id == cityId)[0].name;
    this.currentCityId = cityId;
  }

  editCity(id: any) {
    this.router.navigate(
      ['/system/update-city'],
      { queryParams: { cityID: id } });
  }

  deleteCity(id: any) {
    this.systemService.deleteCity(id)
      .subscribe(
        data => {
          window.location.reload();
        },
        error => {
          this.toastrService.show(this.translate.instant('CAN_NOT_DELETE'));

        }
      );
  }

}
